export default __webpack_public_path__ + "logo.153870905587090a6f5c5543f14a4966.svg";